module.exports = "/_next/static/resources/photo-1-a6d5863351c8ec95ae9d9d11538eebac.jpg";